import { render, staticRenderFns } from "./DocumentNameClickable.vue?vue&type=template&id=1210fb00&"
import script from "./DocumentNameClickable.vue?vue&type=script&lang=ts&"
export * from "./DocumentNameClickable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports